import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter,  Inject, Input, OnDestroy, OnInit, Optional, Output, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MEDIA_TOKEN } from '../../../../../tockens';
import { HotelFiltersService } from '@app/services/hotelfilters.service';

@Component({
    selector: 'clever-traveller',
    templateUrl: './traveller.component.html',
    styleUrls: ['./traveller.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class TravellerComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() reisende: any;
    @Output() sendRes: EventEmitter<any> = new EventEmitter();
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    media: string = 'lg';
    origin = 'default';
    zielText = '2';
    nbAdult: number = 2;
    nbChildren: number = 0;
    childrenList: any[] = [];

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected hotelService: HotelFiltersService,
        protected render: Renderer2,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        this.initFilterSub();
    }

    initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter) => {
            if (filter?.reisendeResult) {
                this.reisende = filter?.reisendeResult;
                if (this.reisende?.adults > 0) {
                    this.zielText = (Number(this.reisende.adults) + this.reisende.children.length) + '';
                    this.nbAdult = Number(this.reisende.adults);
                    this.nbChildren = this.reisende.children.length;
                    this.childrenList = this.reisende.children;
                    this.cdr.detectChanges()
                } else {
                    this.zielText = '2';
                }
            } else {
                this.zielText = '2';
            }
            this.cdr.detectChanges();
        });
    }
    

    initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openModal(ev) {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal() {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any) {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    selected() {
        this.zielText = (this.nbAdult + this.nbChildren) + '';

        this.sendRes.emit({
            adults: this.nbAdult,
            children: this.childrenList
        });
        this.closeModal();
        this.cdr.detectChanges()
    }

    checkAdult() {
        if (Number(this.nbAdult) > 8) {
            this.nbAdult = 8;
        } else if (!this.nbAdult || Number(this.nbAdult) <= 0) {
            this.nbAdult = 1;
        }
        this.cdr.detectChanges();
    }

    addAdult() {
        if (this.nbAdult < 8) {
            this.nbAdult++;
            this.cdr.detectChanges();
        }
    }

    removeAdult() {
        if (this.nbAdult > 1) {
            this.nbAdult--;
            this.cdr.detectChanges();
        }
    }

    addChildren() {
        if (this.nbChildren < 8) {
            this.nbChildren++;
            this.childrenList.push({
                name: 'Kind ' + (this.childrenList.length + 1),
                age: 0
            });
            this.cdr.detectChanges();
        }
    }

    removeChildrent() {
        if (this.nbChildren > 0) {
            this.nbChildren--;
            this.childrenList.pop();
            this.cdr.detectChanges();
        }
    }

    removeChildrentAge(ch) {
        if (ch.age > 0) {
            ch.age--;
            this.cdr.detectChanges();
        }
    }

    addChildrenAge(ch) {
        if (ch.age < 17) {
            ch.age++;
            this.cdr.detectChanges();
        }
    }
}
